import React from 'react';

export default function FwArrowDown({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fab fa-youtube' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
